import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

// Types for image classification testing
export type LlmImageClassificationTestInput = {
    imageBase64: string
    mimeType: string
    fileName: string
    target: string
}

export type LlmImageClassificationView = {
    fileName: string
    target: string
    score?: number | null
    justification: string
}

export type TestLlmImageClassificationPromptsQuery = {
    testLlmImageClassificationPrompts: LlmImageClassificationView[]
}

export type TestLlmImageClassificationPromptsQueryVariables = {
    prompt: string
    testCases: LlmImageClassificationTestInput[]
    model?: string | null
}

export const TestLlmImageClassificationPromptsDocument = gql`
    query TestLlmImageClassificationPrompts(
        $prompt: String!
        $testCases: [LlmImageClassificationTestInput!]!
        $model: String
    ) {
        testLlmImageClassificationPrompts(prompt: $prompt, testCases: $testCases, model: $model) {
            fileName
            target
            score
            justification
        }
    }
`

const defaultOptions = {} as const

export function useTestLlmImageClassificationPromptsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        TestLlmImageClassificationPromptsQuery,
        TestLlmImageClassificationPromptsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        TestLlmImageClassificationPromptsQuery,
        TestLlmImageClassificationPromptsQueryVariables
    >(TestLlmImageClassificationPromptsDocument, options)
}

export type TestLlmImageClassificationPromptsLazyQueryHookResult = ReturnType<
    typeof useTestLlmImageClassificationPromptsLazyQuery
>
